import { useInfiniteQuery } from "@tanstack/react-query";

import { axiosInstance } from "../axios/axiosInstance";

export const key = ["memoKey"];
export const useGetInfiniteMemo = (id) =>
  useInfiniteQuery(
    [...key, id],
    async ({ pageParam = 1 }) => {
      const { data } = await axiosInstance.get(
        `comments/profile/${id}?page=${pageParam}`
      );
      console.log("data ===> ", data);
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage.meta?.current_page < lastPage.meta?.last_page
          ? lastPage.meta?.current_page + 1
          : undefined;
      },
      select: (data) => {
        return data?.pages;
      },
      enabled: !!id,
    }
  );
